export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f393751551169e3089e091d2d94bd154661bcf369&name=fetchTypeahead!'